import React from 'react';

const UserContext = React.createContext({
  user: null,
  setUser: () => { },
  school: null,
  setSchool: () => { },
  objects: null,
  setObjects: () => { }
});

export default UserContext;